import axios from 'axios'
import { taxUrl, getHeader } from './../config'

const state = {
  taxList: [],
  taxSaldoList: [{
    id: null,
    tax_date: null,
    tax_saldo: '0',
    company_no: null,
    company: null,
    notes: null,
    dpp: '0'
  }]
}

const mutations = {
  SET_TAX_LIST (state, obj) {
    state.taxList = obj
  },
  SET_TAX_SALDO_LIST (state, obj) {
    state.taxSaldoList = obj
  }
}

const actions = {
  getTaxList: ({ commit }) => {
    axios.get(taxUrl, { headers: getHeader() })
      .then(response => {
        commit('SET_TAX_LIST', response.data.data)
      })
  },
  getTaxSaldoList: ({ commit }, payload) => {
    axios.get(taxUrl + '/saldo?begin=' + payload.begin + '&end=' + payload.end + '&company=' + payload.company, { headers: getHeader() })
      .then(response => {
        commit('SET_TAX_SALDO_LIST', response.data.data)
      })
  }
}

export default {
  state, mutations, actions
}
